import HttpRequest from '@/libs/axios';
const baseUrl = process.env.VUE_APP_BASE_API;
const baseUrlPrint = 'http://localhost:9088';
//const baseUrl = window.location.protocol + window.location.host ;
const axios = new HttpRequest(baseUrl);
const axiosPrint = new HttpRequest(baseUrlPrint);

export { axiosPrint };
export default axios;
